import { Step } from 'react-joyride';

export const buyerProfileSteps: Step[] = [
  {
    target: 'body',
    content: 'Manage your buyer account, investment preferences, and subscription settings all in one place.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="profile-tabs"]',
    content: 'Navigate between Personal Info, Investment Preferences, Subscription, and Billing tabs to manage different aspects of your account.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="profile-image"]',
    content: 'Upload a professional photo to build trust with sellers. A good profile picture helps you stand out.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="personal-info"]',
    content: 'Keep your contact information up to date so sellers can easily reach you about properties.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="security-section"]',
    content: 'Protect your account with password management and two-factor authentication (2FA).',
    disableBeacon: true,
  },
];
